import {IntermediatePart} from "../../intermediatePart";

export default class ShowerDoorHandle extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_door_handle';
    this.partName = 'Handle';
    this.translateId = "visualizer.bathroom.shower.shower_door_handle";
    this.dbName = 'Shower Door Handle';
    this.visible = true;
    this.isStoneFeature = false;
    this.layerPriority = 9;
    if (isChild) {
      this.previouslySelectedFeatures = {
        Layout1: {},
      };
    }
  }

  load(dbFeature) {
    const handle = this.load_(dbFeature, new ShowerDoorHandle());
    if (handle) {
      ShowerDoorHandle.setAdditionalMetaData(handle);
    }
  }

  static setAdditionalMetaData(handle) {
    const compatible = handle.metaData["CompatibleTub"];
    const showerSize = handle.metaData["ShowerSize"];
    if (!compatible) {
      handle.metaData["CompatibleTub"] = ["None"];
    }
    if (!showerSize) {
      handle.metaData["ShowerSize"] = ["60in"];
    }
  }

  disabledClick() {
    const showerDoor = this.getParent().showerDoor;
    if (showerDoor) {
      showerDoor.disabled = this.disabled;
    }
  }

  handleClick() {
    super.handleClick();
    // this.getParent().getParent().setShowerTubCombo();
    //
    // let doorWithLiner = false;
    // if(this.metaData && this.metaData.length) {
    //   const activeDoorMetadata = this.metaData.find(metaDataObject => metaDataObject.isFor);
    //   const showerPanValues = activeDoorMetadata.conditions.find(condition => condition.name === "BathtubLiner");
    //   if (showerPanValues) {
    //     doorWithLiner = true;
    //   }
    // }
    //
    // this.getParent().getParent().setLinerActive(doorWithLiner);
    // this.featureClicked();
  }

  setLayers(layout) {

    const showerParent = this.getParent();

    if (!showerParent.showerDoor || !showerParent.showerDoor.activeFeature ||
      (showerParent.showerDoor.activeFeature.metaData && showerParent.showerDoor.activeFeature.metaData["ShowerHandle"]
      && showerParent.showerDoor.activeFeature.metaData["ShowerHandle"][0] === "None")) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  // getArrayOfConditions() {
  //   const layout = this.getParent().layout;
  //   const showerComboParent = layout.parts[ShowerTubCombo.id];
  //   const showerParent = this.getParent();
  //   const layoutAbr = layout.getCurrentLayoutAbbreviation();
  //
  //   let showerSize = showerComboParent.showerTubComboIsActive
  //     ? showerComboParent.showerSize()
  //     : showerParent.showerSize();
  //
  //   let compatibleValue = "None";
  //   if (showerComboParent.showerTubComboIsActive) {
  //     if (showerComboParent.bottomTub === ShowerComboTubType.bathtub_liner) {
  //       compatibleValue = "BathtubLiner"
  //     } else if (showerComboParent.bottomTub === ShowerComboTubType.replacement_tub) {
  //       compatibleValue = "ReplacementTub"
  //     } else if (showerComboParent.bottomTub === ShowerComboTubType.walk_in_tub) {
  //       compatibleValue = "WalkInTub"
  //     } else if (showerComboParent.bottomTub === ShowerComboTubType.jetted_tub) {
  //       compatibleValue = "JettedTub"
  //     }
  //   }
  //
  //   const conditions = [{
  //     propName: 'ShowerSize',
  //     propValue: showerSize
  //   },{
  //     propName: 'CompatibleTub',
  //     propValue: compatibleValue
  //   }];
  //
  //   if (layoutAbr === LayoutAbbreviation.Large) {
  //     let showerDimensions = showerComboParent.showerTubComboIsActive
  //       ? showerComboParent.showerDimensions()
  //       : showerParent.showerDimensions();
  //
  //     showerDimensions = getMetadataByDimensions(showerDimensions);
  //
  //     const vanity = layout.parts[Vanity.id];
  //     let counterTopSize = vanity.counterTopSize();
  //     if (counterTopSize === '72in' && layout.type === 1 && (showerDimensions !== "Full" || showerDimensions !== "Pony")) {
  //       showerDimensions = "Full"
  //     }
  //
  //     conditions.push({
  //       propName: "EX L",
  //       propValue: showerDimensions
  //     })
  //   }
  //
  //   if (showerParent.showerDoor && showerParent.showerDoor.activeFeature) { // add shower pan condition only if it is shower
  //     const doorCondition = showerParent.showerDoor.activeFeature.metaData["ShowerDoor"];
  //     const handleCondition = showerParent.showerDoor.activeFeature.metaData["ShowerHandle"];
  //     // console.log('doorCondition', doorCondition);
  //     if (doorCondition) {
  //       conditions.push({
  //         propName: 'ShowerDoor',
  //         propValue: doorCondition
  //       })
  //     }
  //     if (handleCondition) {
  //       conditions.push({
  //         propName: 'ShowerHandle',
  //         propValue: handleCondition
  //       })
  //     }
  //   }
  //
  //   if (!showerParent.showerTubComboIsActive()) {
  //     if (showerParent.showerFloorIsActive) {
  //       conditions.push({
  //         propName: "ShowerPan",
  //         propValue: "Threshold"
  //       })
  //     } else if (showerParent.showerPanCombo && showerParent.showerPanCombo.activeFeature) {
  //       conditions.push({
  //         propName: "ShowerPan",
  //         propValue: showerParent.showerPanCombo.activeFeature.metaData["ShowerPan"]
  //       })
  //     }
  //   }
  //   // console.log('conditions', conditions);
  //   return conditions
  // }

  setDefault() {
    const shower = this.getParent();
    const currentActiveFeature = this.activeFeature;
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      this.setDefaultAccordingToPreviousSelect(shower, filteredFeatures, "Brantford");
    }
    this.rememberPreviousSelection(shower, currentActiveFeature);
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.ShowerDoorHandle;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
